import { Card } from '@mui/material';
import type { ReactNode } from 'react';

// Shortest a filled card gets: below this the page scrolls instead of squashing
// the grid it holds.
const FILLED_MIN_HEIGHT_PX = 520;

interface TablesSectionCardProps {
  children: ReactNode;
  /** Takes all the height the page has left, so a grid inside shows as many rows as
   * fit, as it already does for width. */
  fillHeight?: boolean;
}

// Outlined card used by the Tables section.
export const TablesSectionCard = ({ children, fillHeight = false }: TablesSectionCardProps) => (
  <Card
    variant="outlined"
    data-testid="analysis-tables-card"
    sx={{
      p: 4,
      display: 'flex',
      flexDirection: 'column',
      gap: 4,
      minWidth: 0,
      flexShrink: 0,
      ...(fillHeight ? { flex: 1, minHeight: FILLED_MIN_HEIGHT_PX } : {}),
    }}
  >
    {children}
  </Card>
);
